module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("CHAPTER ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle--Body-"
  }, [_vm._v("SIX YEARS LATER")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“My lady, Mr. Winstowe is asking for you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Lady Eden Winstowe turned from her bleak view of Brook Street and acknowledged the butler’s hushed summons with a nod. “Thank you, Bailey. I shall go up presently.” She glanced out the window again, through the splattered raindrops that drowned the world on this dark November morning.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("So the time had come. How strange that it should fall at a season when most of the ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ton")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" had left for their estates to enjoy hunting and holidays, family and friends.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Her throat tightened with the memory of grief. Spencer had been lost to her long ago, before his final illness had drained the life from his body. She had known for years that he wanted to be rid of her, free to marry some fresh young woman with a larger and more reliable income—though it seemed increasingly unlikely that any woman would accept the debauched, unbalanced man he had become. She would gladly have given him that freedom rather than see it end like this, in such pain and bitterness.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Once she’d hated him. Now she felt only pity and helplessness. Lady Eden Winstowe could flout anyone except Death.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“The fire has gone out, my lady. I will send a maid to light it again.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Eden glanced at the coals in the grate, aware of the chill for the first time in hours. “It is quite unnecessary, Bailey. As long as the fire is adequate in Mr. Winstowe’s chamber—”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“It is, my lady. The doctor is still with him, and Mr. Reynolds. Is there anything more I can do for you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The poor man had little enough to do now that they had taken the knocker from the door and closed the house to visitors. “I shall see Mr. Winstowe now, Bailey.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He bowed and retreated from the room, leaving her to face the stairs alone. The stairs that led to yet another ending.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The doctor looked up as she entered, his eyes telling her everything she needed to know. Mr. Reynolds never paused in his silent reading of his Bible, straining to make out the words in the light of the fire. The room stank of the chamber pot, but it was a smell with which Eden had become most familiar.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Eden.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Spencer lay propped up among his pillows, his sallow face gaunt as a skull. The once-handsome dandy was withered and wasted, but she could still see mockery through the swelling of his faded gray eyes and feel his barely veiled contempt. It only made her pity him the more.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Spencer,” she said, knowing that formality was pointless. She sat in the chair beside the bed and took his hand. “You wished to see me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“My gay, beautiful Eden,” he said. His voice was reduced to a husky rasp. “How it must appall you to be trapped here with me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“No, Spencer.” She struggled for words. Their marriage had never included much conversation and far less sympathy. “I only wish—”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“That I’d gone sooner? All these … dreadful weeks of nursing me—” He tried to sit up and coughed, a deep, racking sound followed by a wheeze as he fought to breathe. Dr. Jones placed a gentle hand on his shoulder and eased him back down.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I wish that we might have made a real peace before this")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(", Eden thought. There was still time. One last chance.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I wish that I had been a better wife to you,” she said. “I wish that I could have made you happy.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He laughed. “Oh, you did … for a while, lovely Eden. As long as the money lasted.” His breath rattled, but he summoned up his strength and continued. “Unfortunately, your father did me the great discourtesy of losing his wealth and most of his land. After all I sacrificed to marry such—” He closed his eyes and shuddered. “But that would be most indelicate of me, would it not?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Eden well knew what he’d been about to say. With the bribe of a steady and generous income, her father had arranged her expeditious marriage, five years ago, to an impoverished but well-placed viscount’s son. Spencer Winstowe, practiced rake and gamester, had known she was not a virgin.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He had not known about the child who had died. Papa had taken great pains to hide that scandal from both Society and the local folk of Hartsmere. But he could not silence the rumors of an elopement, and Spencer had never let Eden forget that he had been “forced” to marry her.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Even when he began to be ill after the first year of their marriage, he would not accept her concern or solicitude. He openly preferred his bits of muslin and gaming hells to her company. His increasing ill health did not slow him but drove him to even greater extremes in a mad quest for every sort of dissipation available to a man with connections, money, and no restraint.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He and Eden went their separate ways, like so many couples of the ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ton")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(". Aunt Claudia’s instruction in the ways of Society had saved Eden. She had learned how to pretend that nothing was wrong, that sorrow could not touch her.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Even when the money stopped coming, and Spencer cursed her to hell.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But nothing had taught her to look upon death as she had come to view all the other exigencies of life with her husband. This was no joke to be laughed away with a mask of cynical indifference.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“However,” Spencer said, cutting into her thoughts, “we have no more leisure for delicacy.” He turned his head on the pillow to catch the doctor’s eye. “What I have to say to my wife is not for your ears. Get out.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The doctor and clergyman exchanged wary glances. “Mr. Winstowe,” the physician said. “I strongly feel that—”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Get out, I tell you—if you want your fees paid!” Spencer began to cough again, and both men reluctantly sidled out the door.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I suggest you … make certain that the door is closed,” Spencer said hoarsely. “You will not wish what I have to tell you to become fodder for the gossip mill … at least … not yet. It may be too much even for your band of aristocratic wantons.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Eden checked the door and returned to stand by the chair, gripping it for support. Spencer would not go to such elaborate lengths unless what he had to tell her was bad indeed. And he had nothing to lose.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You should not upset yourself, Spencer,” she said. “Can we not make peace—”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Peace? I shall be quite at peace soon enough, provided there are whores and card games aplenty in hell.” He wheezed a laugh. “But you, my dear, shall have your reckoning here in this world.” His thin, pale hands moved restlessly over his sunken chest. “Blast it, where is that letter? No matter. You … sit, my loving wife. I would not have you swoon.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Eden’s fingers pushed deep into the padding of the chair. “Please, Spencer.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Very well.” He turned his head slowly, until he could look into her eyes. “A most interesting piece of information came my way not long ago. I debated for some time whether or not to tell you … but it would be cruel to take it with me to my grave.” He smiled. “You had a son, Eden. One you and your father failed to mention.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Eden had mastered the ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ton")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("nish art of hiding her true feelings. Denial was pointless. “You knew when you married me that I was not untouched.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Oh, yes. You were no weeping virgin, more’s the pity. But I did not know of the child.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“The child—” ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("My son.")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" “It would have made no difference. The child did not survive.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Oh, but he did. Your son is very much alive.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("All at once the rejected chair seemed essential if she wished to remain upright. “Alive?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Indeed. It seems that he has been—” He sucked in air, as if it were becoming harder and harder to fill his lungs. “He’s been living all these years with peasants in some … filthy hovel.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“But how—” She closed her mouth and struggled for control. ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("How can that be?")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You’re an … excellent actress, Eden, but I can see through you. How can a … a child’s own mother not know he is alive?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Because Papa told me. And I believed.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Lies … and … deceptions—” Spencer broke into a fit of coughing that became dry, barking heaves, though he could not have anything left in his stomach to bring up. She hadn’t been able to make him eat in days. She knelt by his side and held him until the fit passed, but it seemed to have torn something inside, letting all the force of his life leak out of his body.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“How … tender you are,” he said. “You want more. But I … have no more to give.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Spencer,” she said, leaning close. “I beg you. Where is my son?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("His laugh became a rattle. Eden sprang to her feet and stumbled to the door.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Doctor,” she cried. “Mr. Reynolds. My husband—”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The two men, who had been waiting at the end of the landing, hurried to join her. The doctor swept past her into the room, but the clergyman paused to take her hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Be not troubled, my lady,” he said. “He is in God’s hands.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She murmured the appropriate response and stood aside to let him follow the doctor. Spencer’s breathing was too labored to permit speech. The drone of Mr. Reynolds’s voice drifted through the door, extolling the joys of life everlasting.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Eden composed herself and went to her husband for the last time. She knelt and tried to pray—for Spencer, for herself, and for the son she had never known. Most of all for her son. But the prayers were ashes in her mouth, with nothing behind them but convention and the lost faith of childhood.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“My lady.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She looked up at the brush of Mr. Reynolds’s hand on her shoulder. “It is over. Your husband is at rest. His pain is ended.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Convention saved her. “Thank you, Mr. Reynolds. I am grateful for the comfort you have given to us.” She accepted the clergyman’s arm and rose, staring blindly across the landing. Yes, Spencer’s pain was ended. She was glad for that measure of mercy.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But my son. Oh, Spencer, where is my son?")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The child she had borne but never knew. Never held in her arms. Never rocked to sleep. The son who had left her womb an aching void.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She started downstairs in a daze. Bailey and several of the maids and footmen stood at the bottom, pale and anxious.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Eden did not begrudge them their concerns. They had not only lost a master this day but likely their positions as well. As long as Winstowe lived, they had all been able to maintain the fiction that wealth and plenty were endless, money a concern unbefitting such well-placed members of the ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ton")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("That fable had reached its inevitable conclusion.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The front door opened before Bailey could perform the service. Aunt Claudia stood on the threshold, rain dripping from her pelisse. She removed it and handed it to the footman, fingers already busy with the ties of her bonnet.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I came as quickly as I could,” she said. “The messenger—” She broke off as she met Eden’s eyes. “Oh, my dear.” She opened her arms, and Eden walked into them as she had done so many times for as long as she could remember.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Claudia drew her into the morning room and pressed her into the chaise longue. “When?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It was so like her aunt to drive to the heart of the matter. There was something deeply comforting in such practicality. “Only moments ago,” Eden said. “I was with him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I am sorry,” Claudia said. But Eden knew that all her pity was for the living, not the dead.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Whatever he may have done—whatever you may have thought of him—he did not deserve any of this. Nor did you. You cared for him with no thought for yourself during this past month, and you are worn to a nub. There is nothing more you could have done.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“No thought for myself?” Eden rose and moved with aimless steps toward the marble mantelpiece. “When did I ever do anything with no thought for myself?” She stopped before the ornate mirror hung over the mantel, hardly recognizing the sunken-eyed, brittle creature in the reflection. “We all pay for our follies, do we not?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You have paid for your husband’s. Now you are free of him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Claudia’s merciless judgment left Eden cold to the bone. Had this not been her beloved aunt, the woman who was dearer than a mother to her …")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The woman whose unsentimental pragmatism was so very reassuring. Who spoke aloud what Eden thought and despised herself for thinking.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She took a careful breath. “There is at least one folly that is mine alone. One that Spencer had no part of.” She turned to face her aunt. “He had a farewell gift for me, a final declaration.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“He gave me back my son.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("laudia did not allow her face to show so much as a flicker of astonishment. She had been the one to teach Eden how to confront the world as if nothing mattered, as if every little trouble could be cast aside with a casual wave of a well-gloved hand and a satirical laugh.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But this she had not expected. The young woman who stood before her was more than merely exhausted and distressed by the long weeks of Spencer’s illness and her own preposterous sense of guilt. The drastic changes in the niece Claudia knew—the niece who had most of the ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ton")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" wrapped around her smallest finger—should not have lasted long beyond Spencer’s death. Claudia had counted on Eden’s natural resilience.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Now she knew that Spencer had found a way to poison Eden’s life even from beyond the grave. For Eden’s eyes were filled not with returning sanity but with tears of hope.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Ruinous hope.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Your son?” Claudia said, rising quickly. She hurried to Eden’s side and took her hand. It felt terribly thin and fragile, as if it might snap with the slightest of pressure. “I do not understand. How could Spencer claim to know such a thing? How could even he be so cruel?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Eden shook her head. “I do not care why he told me or how he discovered it. He said that my son is alive, in the countryside, living with some family—” Her desolate gaze took on the first real brilliance it had shown since Spencer’s illness. “My son, dear Aunt. You and Papa told me he had died.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("There was as yet no accusation in her voice. No suspicion, only bewilderment and hesitant joy.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Curse Spencer Winstowe to hell. He’d had the last laugh, it seemed. But he was dead, and Claudia was very much in control. As she had always been, and always would be.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Denying Spencer’s claim would be most unwise. Eden was confused at the moment, but she had never been dull.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Sit down, my dear,” she said, guiding Eden back to the chaise. “I see that I must explain what 1 had hoped to spare you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Eden had not been an innocent for many years. All of Society saw her as sophisticated and up to every rig and row. She had survived disappointment and the destruction of each callow, youthful dream, and replaced them with more immediate pleasures.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But she had not grown quite impervious enough. She was still capable of feeling betrayed.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You knew?” she asked in a whisper.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“No. I only suspected.” Claudia gazed down at her hands as if reluctant to speak. “I know you do not remember much of what happened during the child’s birth. You were delirious, and it was not going well. My brother—your father—insisted upon employing the services of a local midwife rather than a physician. The woman sent me from the room when the child was born, despite all my pleas to stay by your side.” She looked up, allowing sorrow to shadow her eyes. “Afterward your father came to tell me that he had spoken to the woman, and that the child … had not survived.” She reached for Eden’s hand. “I could not bring myself to doubt him, though deception … had occurred to me. I never saw the child—or the midwife—again.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Eden’s profile was bleak. “My father?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“If he deceived you, my sweet child, it was for the best. You were …very ill before and after the child’s birth. You wanted nothing to do with its father. And Lord Bradwell himself was … not well.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She saw that point strike home. Eden never showed that she missed her father. He had been half mad ever since that night at the inn on the way to Gretna Green.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("In the year after Eden’s marriage to Winstowe, Lord Bradwell had gambled and caroused his way through his fortune and all his unentailed lands. Claudia remembered how he’d deteriorated, driven by guilt and shame, only to disappear from sight and cut off all contact with his only child. He was rumored to be dead, or living in exile on the continent. Even Lord Bradwell’s solicitor had no news of him. Eden had stopped inquiring years ago.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“He gave my son away,” Eden said. “That changes nothing. I must find him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Find your son?” ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Or your father? Thank God that either will be nearly impossible.")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" “Did Spencer tell you where to look for him?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“No. It does not matter. I shall find him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“But why, Eden?” Claudia leaned close, Filling her voice with sympathetic persuasion. “Think of the child. Surely he is better off wherever he is, among those who raised him. Whatever his reasons, your father would have seen to it that he went to a good and decent family, with means enough to raise him properly. He does not know you—”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I am his ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("mother")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(".”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“And who was his father?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Stricken, Eden closed her eyes. “You think I could not love him because—” She shook her head. “You are wrong.” She opened her eyes again and held Claudia’s gaze, her elegantly curved brows drawn in an expression that was almost savage. “Can you think that I am the same naive girl who came to London five years ago? After all you have taught me?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Claudia could not mistake the edge of mockery in her voice. The cynicism of lost innocence underlay everything Lady Eden did, everything she was.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Except in the matter of her resurrected child.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You know nothing of children,” Claudia said with deliberate coldness. “You never behaved as if you wanted any.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“There are still things you do not know about me, Aunt.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But I know that in five years of marriage, Spencer never gave you a child. I believe I know why. Yet none of the lovers did, either.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("God knew that she had taught Eden to be careful.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“A woman alone,” she said, “left as Spencer has left you—”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Nearly penniless?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("So Eden was not unaware of the state of her finances, though she had lived as though the money would last forever. Claudia admitted she bore some of the blame for that; she had indulged the girl too much. But she could also supply the remedy—once she had put an end to this madness about Eden’s son.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Spencer left many large debts of long standing,” she said. “The creditors will be sending in their bills now that he is dead.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Yes. But I suspect that is not your greatest concern, Aunt. Can it be that you fear for my reputation?” She laughed, the throaty, musical sound that drew men to her like bees to a blossom. “That I shall somehow ruin myself by suddenly producing a son who is not my husband’s?” Her smile held a wild, irrational edge. “Everyone knows that Lady Eden Winstowe is almost beyond redemption. Why should the ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ton")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" be shocked?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Even a liberal society has its limits,” Claudia said firmly. “You have always taken my advice before, and I give it to you in all familial affection. Your position may be more precarious than you will admit, now that your income is so vastly reduced. Do you wish to be ostracized by the ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ton")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("?")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Eden lost her smile. That point, too, hit its mark. “I have friends—”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And have you not learned how little such friendships can mean?")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" “In this last year, Spencer was more intemperate than ever before. You know that he was not right in the mind. He accumulated the sorts of debts, and reputation, that caused much ill will among those who were once his friends. The ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ton")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" was already beginning to cut him, Eden. You were simply too involved in your own affairs to notice, but it would have affected you soon enough. And now … think, my dear. You must have time to consider carefully. This is no time for rash action.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She gestured about the room, at the fine furnishings and rare antiques. “You can no longer bear the expense of running such an extravagant household. Your father’s investments have failed. The income from your marriage settlement has fallen to a trickle, and not enough remains to pay your debts and continue in any fashion that would maintain your place in Society. Nor can I help, for my own jointure …” She paused delicately.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I know, Aunt. I have done my best to repay you for all you have done, but now … I do not know how I shall help you to maintain your own establishment.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“That is of no moment, dear Niece. But how can you consider bringing an innocent child, raised by simple folk, into this questionable situation?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Eden’s face had grown unreadable once more. “We shall sell this house and the furnishings and move to more modest lodgings.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Where? In Hans Town, perhaps? Would you really care to receive your fashionable friends draped in dull mourning garb, no longer able to join in their scandalous conversation and too impoverished to charm them with expensive entertainments?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Eden stood again, her swift movements belying her apparent calm. “I am well aware of the necessities. I will reduce the staff as well, though it grieves me. We must sell Spencer’s horses and three of the carriages. That alone will settle many of Spencer’s debts, those that cannot wait.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“And what of your own?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“What do you suggest, Aunt? If we cannot afford to live as we have become accustomed to do, and we are in such danger of being cut by the ton, then where are we to go? I can think of but one place that remains mine without encumbrance.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Claudia tried not to shudder. There was, indeed, one sanctuary open to Eden, a place to which she had sworn she would never return. One Claudia dreaded with equal fervency.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Hartsmere.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Not that Lord Bradwell had believed his daughter would return. He had come to hate the place as much as his sister and daughter had. But he had been determined to give Eden some refuge of her own in the event of dire need. Hartsmere was unentailed, and had become part of the marriage settlement; Spencer had only its income while he lived. Income that had rapidly diminished to nothing.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Surely you cannot be serious,” Claudia said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Eden closed her eyes. “Have we any choice? Papa made certain that it would come to me upon my husband’s death, and it cannot be touched by our creditors.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Spencer had no experience or interest in management, and never put a penny back into that estate. It must be in ruins. I will not allow you to make such a sacrifice when there is a far more sensible solution.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Pray tell me, Aunt. If there is another way—”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“The Marquess of Rushborough.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Eden blinked, as if the thought had never entered her mind. Perhaps it hadn’t. She’d broken with the marquess as soon as Spencer became ill.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Claudia was not so imprudent. “Do you think that the marquess has forgotten you in one short month? He was very much in love with you, Eden—and do not pretend that you were indifferent to him. He was not your usual flirt. I have no doubt that, if you were to approach him—”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Spencer has just died,” Eden interrupted, her voice unsteady. “I am in mourning. You say that you are afraid of my scandalizing the ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ton ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("by finding my son, but begging support from Rushborough is acceptable?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“The marquess can be most discreet. And it is not his mistress he would be supporting, but his future wife.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Eden gazed unseeing about the room. “What has Rushborough told you of his intentions?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“His actions are more eloquent than any words could be. Naturally you must maintain a show of mourning your husband. But I have every confidence that if you provide the smallest encouragement, Rushborough will propose—and marry you as soon as you put away your widow’s weeds. Until then, he will not allow his beloved to live in disgrace or poverty.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Eden’s expression relaxed, and Claudia was certain she had won. Everything she had said was true. “You see how this solves all our problems. You will have the life you deserve, with no fear of debt. As a marchioness, you shall be—”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“No. I am sorry, Aunt, but it is too soon. I cannot ask so much of Rushborough. And before I see him again, I must find my son.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I thought we had discussed the folly of such a scheme.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Eden’s expression took on the willful, reckless look that Claudia had seen more and more frequently. “It is no scheme. Aunt. It is my firm resolve.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Claudia kept a tight rein on her temper. Once, six years ago, she had forcefully tried to dissuade a young girl from throwing her life away, and her protestations had only driven Eden into her lover’s arms. The same thing might happen again if she pressed too hard.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But once Eden returned to Hartsmere, she would not be able to bear the place for long. Soon she would be desperate to take her aunt’s advice, as she had done for the past five years, and accept the marquess’s generosity.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("And Eden’s hopes of finding the boy were slim. She might search for years and never locate him. By one means or another, Claudia would steer Eden’s thoughts away from this lunacy.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("This incalculable danger.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Very well,” Claudia said. “If it is your wish to go to Hartsmere, there is much to be done, many preparations to be made—funeral arrangements and lawyers to consult. We must write the steward at Hartsmere to inform him of your return.” She took Eden’s arm. “Leave it all to me, my dear. You need rest.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("As if to give the truth to her words, Eden swayed on her feet. The fight had gone out of her, now that she believed she had her way.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You will not wish to go upstairs quite yet. Sit quietly and reflect, and Bailey will bring you a soothing glass of wine.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("With a faint murmur of thanks, Eden assented. Bailey hastened to do Claudia’s bidding; he knew who had taken the reins of authority in this household.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Once Eden was well settled, Claudia went into the study and unlocked Spencer’s desk with the duplicate key she had obtained during his illness. It wasn’t difficult to find the letter; Spencer had not been a particularly clever man nor a very imaginative blackmailer. She still did not know when or how Spencer had come by the missive. He had made good on his threat to tell Eden of her son, but he was quite unable to savor his victory in hell.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Claudia folded the paper tightly and pocketed it among her skirts. She had a letter of her own to write, and its recipients had best be wiser than Spencer Winstowe.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0066ed4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ForestLord-2.vue
// module id = 72
// module chunks = 0